import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CategoryService } from '../../_services/category.service';
// deneme
@Component({
  selector: 'app-category-summary',
  templateUrl: './category-summary.component.html',
  styleUrls: ['./category-summary.component.scss']
})
export class CategorySummaryComponent implements OnInit {

  country: string;
  language: string;

  categoriesArray: any;
  hoverEffect: string;


  constructor(
    private route: ActivatedRoute,
    private categoryService: CategoryService,

  ) {
    const routeParams = this.route.snapshot.params;
  }

  getCategories(country: string, language: string): void {
    this.categoryService.getCategories(country, language)
      .subscribe(
        resultArray => {
          this.categoriesArray = resultArray;

          // removes blank parent categories
          let tmp=[]
          for (let key in this.categoriesArray.categories) {
          console.log(this.categoriesArray.categories[key].child.length);
            if(this.categoriesArray.categories[key].child.length != 0){
              tmp.push(this.categoriesArray.categories[key]);
            }
         };

         this.categoriesArray.categories = tmp;
        },
        error => console.log('Error ::' + error)
      );
  }

  ngOnInit(): void {

    setTimeout(() => {
      const pathname = window.location.pathname;
      const pathnameSplit = pathname.split('/');
      this.country = pathnameSplit[1];
      this.language = pathnameSplit[2];
      this.getCategories(this.country, this.language);
    }, 1500);
  }
}
